export default __webpack_public_path__ + "static/media/images-discord-button.8fbc6a40.svg";